export const TICKER_REGEX = /\$[A-Za-z][A-Za-z0-9._&-]*/g;

export const TICKER_TRIGGER_REGEX = /\$([A-Za-z][A-Za-z0-9._&-]*)$/;

export const isTicker = (value: string): boolean => /^\$[A-Za-z][A-Za-z0-9._&-]*$/.test(value);
